<script lang="ts" setup>
import { computed, h, navigateTo, onMounted, ref, useRoute } from '#imports';
import { CaretDownOutlined, SearchOutlined } from '@ant-design/icons-vue';
import { QUERY_KEY_FOR_MODEL } from '@core/utils/constant';

// 搜索页面
const name = ref('oj_problem');
// 搜索内容
const content = ref();
const route = useRoute();

const NAME_OPTIONS = [
  { label: '题目', value: 'oj_problem', tip: '输入题目编号或名称' },
  { label: '题单', value: 'oj_training', tip: '输入题单编号或名称' },
  { label: '比赛', value: 'oj_contest', tip: '输入比赛名称' },
];

const findNameIndex = (str: string) => {
  for (let i = 0; i < NAME_OPTIONS.length; i++) {
    if (NAME_OPTIONS[i].value === str) {
      return i + 1;
    }
  }
};

const placeholderText = computed(() => {
  const found = NAME_OPTIONS.find((item) => item.value === name.value);
  return found?.tip;
});

const handleSearch = async () => {
  if (content.value) {
    const type = findNameIndex(name.value);
    window.hetaoTrack('oj_homepage_serach_click', { type });
    await navigateTo(
      {
        name: name.value,
        query: {
          [QUERY_KEY_FOR_MODEL]: JSON.stringify({
            keyword: content.value,
          }),
        },
      },
      {
        external: true,
      },
    );
  }
};

onMounted(() => {
  const routeName = route.name as string;
  const nameIndex = findNameIndex(routeName) || 0;
  if (nameIndex > 0) {
    name.value = routeName;
  }
});
</script>

<template>
  <div
    v-track:newoj_navi_search_show
    class="!border-colorFill ml-auto flex h-7 items-center rounded !border bg-white"
  >
    <a-select
      v-model:value="name"
      :bordered="false"
      size="small"
      placement="bottomLeft"
      :suffix-icon="h(CaretDownOutlined)"
      :options="NAME_OPTIONS"
      class="fix-select"
    >
    </a-select>

    <a-input
      v-model:value="content"
      :bordered="false"
      size="small"
      class="placeholder:text-colorTextQuaternary !w-36 !text-sm !leading-5"
      :placeholder="placeholderText"
      @press-enter="handleSearch"
    />

    <a-button
      v-track:newoj_navi_search_click.click
      type="text"
      size="small"
      class="!w-auto !px-2"
      @click="handleSearch"
    >
      <template #icon>
        <img src="@core/assets/image/icon/searchIcon.svg" alt="" />
      </template>
    </a-button>
  </div>
</template>

<style scoped>
:deep(.fix-select .ant-select-selection-item) {
  font-size: 14px;
}
</style>
